<template lang="html">
    <div class="main">

      <div class="core">

        <div class="header_fix">
          <div class="header_icon" @click="$router.push('/index')"><img src="@/assets/index/Groupa2.png"></div>
          <div class="header_icons"  @click="$router.push('/index')"><img src="@/assets/index/Group 2.png"></div>
          <ul class="header_list">
        <li v-for="(item,index) in headerList" :key="index" :class="item.current?index==11?'clearfix active':'active':index==11?'clearfix':''"  @click="handleClick(item,index)" >{{item.name}}
          <div class="second_list" >
                    <i></i>
                    <ol >
                        <li v-for="(secondItem,secondIndex) in secondList" :key="secondIndex" @click.stop="handleCommand(secondItem.command)">{{secondItem.name}}</li>
                    </ol>
                </div>
        </li>
        <li class="clearfix"></li>
          </ul>
          <div class="header_right">
            <div class="header_relative">
              <div class="header_phone" v-show="!flag"><i></i>{{this.$store.state.phone}}</div>
              <div class="header_sreach" :class="flag ? 'active':''">
                <i></i><input placeholder="搜索内容" v-model="input" @focus="change(1)" @blur="change(2)">
                <div class="header_btn" v-show="flag" @click="changeNav">搜索</div>
              </div>
            </div>
          </div>
        </div>
        </div>

      </div>

    </div>
</template>

<script>
export default {
  data () {
    return {
      flag: false,
      headerList: [
        {
          name: '首页',
          path: '/index',
          router: { name: 'index' },
          current: true
        },
        {
          name: '咨询',
          path: '/server',
          router: { name: 'server' },
          current: false
        },
        {
          name: '培训',
          path: '/cultivate',
          router: { name: 'cultivate' },
          current: false
        },
        {
          name: 'IT咨询',
          path: '/itService',
          router: { name: 'itService' },
          current: false
        },
        {
          name: '金合资本',
          path: '/capital',
          router: { name: 'capital' },
          current: false
        },
        {
          name: '上市助推',
          path: '/listed',
          router: { name: 'listed' },
          current: false
        },
        {
          name: '商学院'
        },
        {
          name: '专家团',
          path: '/team',
          router: { name: 'team' },
          current: false
        },
        {
          name: '客户案例',
          path: '/case',
          router: { name: 'case' },
          current: false
        },
        {
          name: '商务合作',
          path: '/business',
          router: { name: 'business' },
          current: false
        },
        {
          name: '人才招聘',
          path: '/recruit',
          router: { name: 'recruit' },
          current: false
        },
        {
          name: '关于我们',
          path: '/aboutUs',
          router: { name: 'aboutUs' },
          current: false
        }
      ],
      secondList: [
        {
          name: '金蓝盟简介',
          command: 0
        },
        {
          name: '企业文化',
          command: 1
        },
        {
          name: '董事长公开信',
          command: 2
        },
        {
          name: '集团新闻',
          command: 3
        }
      ],
      num: 0,
      isShow: false,
      input: ''
    }
  },
  watch: {
    $route: {
      handler (val) {
        this.headerList.map(nav => {
          nav.current = false

          if (nav.router && nav.router.name === val.name) {
            nav.current = true
          }
        })
      },
      immediate: true
    }
  },

  methods: {
    leave () {
      this.isShow = false
    },
    change (value) {
      if (value === 1) {
        this.flag = true
      } else {
        setTimeout(() => {
          this.flag = false
        }, 300)
      }
    },
    handleClick (item, index) {
      if (index == 6) {
        window.open('http://www.jlmedu.com/#/index')
      }
      let path = this.$route.path
      if (path === item.path) {

      } else {
        this.$router.push(item.path)
      }
    },
    changeNav () {
      this.$router.push({ path: '/sreach', query: { value: this.input } })
    },
    handleCommand (command) {
      if (this.$route.path === '/aboutUs') {
        if (+this.$route.query.num == command) {
          return
        }
        this.$router.push({
          path: '/aboutUs',
          query: { num: command }
        })
        return
      }
      this.$router.push({
        path: '/aboutUs',
        query: { num: command }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.clearfix:hover {
  .second_list {
    display: block;
  }
}
.main {
  position: fixed;
  top: 0;
  height: 80px;
  width: 100%;
  z-index: 999;
  min-width: 1360px;
  left: 50%;
  transform: translateX(-50%);

  -ms-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  // background-color: #2D2E38;
}
.core {
  display: block;
  min-width: 1360px;
  margin: 0 auto;
}
.header_fix {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  .header_list {
    // overflow: hidden;
    li {
      float: left;
      list-style: none;
      margin-left: 24px;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      padding: 8px 0;
      cursor: pointer;
      position: relative;
      border-bottom: 2px solid transparent;
    }
    li.active {
      color: #fff;
      border-bottom: 2px solid #2e54eb;
    }
    li:hover {
      color: #fff;
      border-bottom: 2px solid #2e54eb;
    }
  }
}
.header_icon {
  display: none;
  width: 280px;
  height: 80px;
  overflow: hidden;
  cursor: pointer;
  img {
    display: block;
    width: 100%;
  }
}
.header_icons {
  display: block;
  width: 120px;
  height: 42px;
  overflow: hidden;
  cursor: pointer;
  img {
    display: block;
    width: 100%;
  }
}
.header_right {
  flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 12px;
  height: 40px;
  justify-content: flex-end;
  .header_phone {
    line-height: 40px;
    font-size: 24px;
    color: #ffffff;
    margin-right: 18px;
    i {
      margin-right: 8px;
      display: inline-block;
      vertical-align: top;
      height: 40px;
      width: 24px;
      background: url("~@/assets/index/phone.png") no-repeat center center;
      background-size: 24px 24px;
    }
  }
}
.header_sreach.active {
  width: 322px;
  input {
    flex: 1;
  }
}
.header_sreach {
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  // position: absolute;
  // right: 0;
  // top: 0;
  display: flex;
  display: -webkit-flex;
  overflow: hidden;
  i {
    margin-left: 16px;
    margin-right: 8px;
    vertical-align: top;
    width: 16px;
    height: 40px;
    background: url("~@/assets/index/sreach.png") no-repeat center center;
    background-size: 16px 16px;
    display: inline-block;
    opacity: 0.2;
  }
  input {
    display: inline-block;
    vertical-align: top;
    width: 64px;
    background: none;
    border: none;
    line-height: 40px;
    padding-right: 16px;
    outline: none;
    color: rgba(255, 255, 255, 0.4);
  }
  input::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  input:-moz-placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  input::-moz-placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
}
.header_relative {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  align-items: center;
  // width: 322px;
  // position: relative;
  height: 80px;
  width: 100%;
}
.header_btn {
  width: 72px;
  height: 40px;
  background: #2e54eb;
  border-radius: 0px 4px 4px 0px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  display: block;
}

.second_list {
  position: absolute;
  width: 180px;
  left: -15px;
  top: 37px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.2);
  display: none;
  padding-top: 20px;
  cursor: pointer;
  z-index: 11;
  i {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    position: absolute;
    left: 36px;
    top: 12px;
  }
  ol {
    background-color: #fff;
    overflow: hidden;
    color: #222222;
    border-radius: 4px;
    padding: 24px 0;
    li {
      color: #222222 !important;
      margin-left: 24px !important;
    }
  }
}

@media screen and (min-width: 1920px) {
  .header_relative {
    width: 365px;
  }
  .header_sreach.active {
    width: 365px;
  }
  .header_right {
    padding-right: 40px;
  }
  .header_phone {
    margin-right: 48px;
  }
  .main {
    position: fixed;
    top: 0;
    height: 80px;
    // width: 1920px;
    width: 100%;
  }
  .header_fix {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    .header_list {
      // overflow: hidden;
      li {
        float: left;
        list-style: none;
        margin-left: 46px;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
        padding: 8px 0;
        cursor: pointer;
        position: relative;
      }
      li.active {
        color: #fff;
        border-bottom: 2px solid #2e54eb;
      }
      li:hover {
        color: #fff;
        border-bottom: 2px solid #2e54eb;
      }
    }
    .header_down {
      width: 200px;
      height: 200px;
      background: #fff;
      position: absolute;
      right: 550px;
      bottom: -201px;
    }
  }
  .header_icon {
    display: block;
    width: 280px;
    height: 80px;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
  }
  .header_icons {
    display: none;
    width: 230px;
    height: 80px;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
  }
  .core {
    display: block;
    // width: 1920px;
    width: 100%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1360px) {
  .second_list {
    right: 300px;
    top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-header.vue